import {
  REQUEST_STATUS_COMPLETED,
  POLLING_ERROR_RETRY_COUNT_MAX
} from '../../../../../share/util/api/polling';
import { executeSyncRequest } from '../../../../../share/util/api/syncRequest';
import apiService from '../../../../../share/util/api/service';
import session from '../../../../../share/session';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import requirement045Utils from './Requirement045Utils';

/**
 * [wsp] データモニタ停止
 * @param {instance} self 呼び出し元this
 * @param {boolean} loadingOff falseならばスピナーOFFしない
 * @param {boolean} isImmediate エラー即時実行フラグ
 * @returns {boolean} 成否
 */
export async function stopMonitor(self, loadingOff, isImmediate) {
  try {
    if (!self.isMonitorStarted) return true;
    self.isLoading = true;
    //バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'stop'
      },
      // エラー発生のコールバックを実装
      (errorType) => {
        if (errorType === POLLING_ERROR_RETRY_COUNT_MAX) {
          // ポーリング回数上限に達した場合、再度POSTから実行
          self.stopMonitor(loadingOff, isImmediate);
        } else {
          self.validateErrorResult({ causeType: 8 }, isImmediate); // other error
        }
      },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result, isImmediate); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result, isImmediate); },
    );
    if (response) {
      if (response.data.status === REQUEST_STATUS_COMPLETED) {
        // 正常終了 : 結果を返す
        self.isMonitorStarted = false;
        return true;
      }
      throw new Error('Unexpected error occurred: ', response.data);
    }
    return false;
  } catch (error) {
    const result = {
      causeType: "callAPIExceptionHandler",
      exceptionHandlerArgs: [requirement045Utils.METHODS.STOP_MONITOR, error, self]
    };
    await self.validateErrorResult(result, isImmediate);
    return false;
  } finally {
    requirement045Utils.terminationHandler(self, loadingOff);
  }
}

/**
 * [wsp] 計測データ削除
 * @param {instance} self 呼び出し元this
 * @param {boolean} loadingOff falseならば成功時にスピナーOFFしない
 * @param {boolean} isImmediate エラー即時実行フラグ
 * @returns {boolean} 成否
 */
export async function clearMeasuredData(self, loadingOff, isImmediate) {
  try {
    if (!self.isMeasureStated) return true;
    self.isLoading = true;
    const response = await executeSyncRequest(
      self,
      async () => {
        const endPoint = `/projects/${self.projectId}/${self.measuredId}`;
        return await apiService.deleteCall(apiService.WSP, endPoint);
      },
      // エラー発生のコールバックを実装
      (errorType) => { errorType; self.validateErrorResult({ causeType: 8 }, isImmediate); }, // other error
      // API レスポンスチェックのコールバック
      undefined,
      // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result, isImmediate); },
    );
    if (response) {
      if (response.data.status === REQUEST_STATUS_COMPLETED) {
        self.isMeasureStated = false;
        return true;
      }
      throw new Error('Unexpected error occurred: ', response.data);
    }
    return false;
  } catch (error) {
    const result = {
      causeType: "callAPIExceptionHandler",
      exceptionHandlerArgs: [requirement045Utils.METHODS.CLEAR_MEASURED_DATA, error, self]
    };
    await self.validateErrorResult(result, isImmediate);
    return false;
  } finally {
    requirement045Utils.terminationHandler(self, loadingOff);
  }
}

export default {
  stopMonitor,
  clearMeasuredData
};